export default __webpack_public_path__ + "static/media/the-weapon-and-the-warrior-face.66b31ca4.jpg";